import createReactComponent from '../createReactComponent';
export default createReactComponent('cup', 'IconCup', [
  ['path', { d: 'M5 11h14v-3h-14z', key: 'svg-0' }],
  ['path', { d: 'M17.5 11l-1.5 10h-8l-1.5 -10', key: 'svg-1' }],
  ['path', { d: 'M6 8v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1', key: 'svg-2' }],
  ['path', { d: 'M15 5v-2', key: 'svg-3' }],
]);
